import { axiosIns } from "../utils";

/** The "Activités" of an enterprise or an organism; null clears it. */
export const updateUserActivitiesApi = async (id, activities) => {
  const res = await axiosIns.patch(`/users/${id}/activities/`, { activities });
  return res && res.data ? res.data : res;
};

export const fetchUsersList = async () => {
  const res = await axiosIns.get("/users/list/");
  return res && res.data ? res.data : res;
};

export const fetchOrganismesUsers = async () => {
  const res = await axiosIns.get("/organismes/");
  return res && res.data ? res.data : res;
};

export const fetchEnterprisesUsers = async () => {
  const res = await axiosIns.get("/enterprisesList/");
  return res && res.data ? res.data : res;
};

export const fetchParticularUsers = async () => {
  const res = await axiosIns.get("/particulars/");
  return res && res.data ? res.data : res;
};

export const fetchUserById = async (id) => {
  const res = await axiosIns.get(`/users/${id}/`);
  return res && res.data ? res.data : res;
};

export const updateUserById = async (id, payload) => {
  const res = await axiosIns.patch(`/profile/${id}/`, payload);
  return res && res.data ? res.data : res;
};

export const createUser = async (payload) => {
  const res = await axiosIns.post("/users/", payload);
  return res && res.data ? res.data : res;
};

/**
 * Full user directory, blocked accounts included.
 *
 * `/users/list/` stays filtered on active users: it also feeds the per-type
 * lists and the messaging recipient picker, which must not offer blocked
 * accounts. Only the administration screen uses this one.
 *
 * `status` accepts "active", "blocked", or nothing for all of them.
 */
export const fetchUsersDirectory = async (status) => {
  const res = await axiosIns.get("/users/directory/", {
    params: status ? { status } : undefined,
  });
  return res && res.data ? res.data : res;
};

export const blockUser = async (id, reason) => {
  const res = await axiosIns.patch(`/users/${id}/block/`, { reason });
  return res && res.data ? res.data : res;
};

export const unblockUser = async (id) => {
  const res = await axiosIns.patch(`/users/${id}/unblock/`);
  return res && res.data ? res.data : res;
};

/** Create an internal staff account (assistant, committee member, admin). */
export const createStaffUser = async (payload) => {
  const res = await axiosIns.post("/users/staff/", payload);
  return res && res.data ? res.data : res;
};

export const changeOwnPassword = async (payload) => {
  const res = await axiosIns.post("/profile/change-password/", payload);
  return res && res.data ? res.data : res;
};
